import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogModule, ButtonModule, InputTextModule, SharedModule, CheckboxModule, RatingModule, DragDropModule, FileUploadModule, AutoCompleteModule, DropdownModule, CalendarModule, LightboxModule, TooltipModule, RadioButtonModule, SpinnerModule, ProgressSpinnerModule, KeyFilterModule } from "primeng/primeng";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { InputTrimModule } from "../../../directives/input-trim/input-trim.module";
import { CurrencyMainPipe } from "../../helpers/currency.pipe/currency.main.pipe";
import { UploadDocumentComponent } from './upload-document.component';

@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        FormsModule,
        HttpModule,
        ButtonModule,
        SharedModule,
        InputTextModule,
        CheckboxModule,
        RatingModule,
        DragDropModule,
        FileUploadModule,
        AutoCompleteModule,
        DropdownModule,
        CalendarModule,
        RadioButtonModule,
        LightboxModule,
        TooltipModule,
        InputTrimModule,
        SpinnerModule,
        CurrencyMainPipe,
        ProgressSpinnerModule,
        KeyFilterModule,
    ],

    declarations: [
        UploadDocumentComponent
    ],

    exports: [
        UploadDocumentComponent
    ],

})

export class UploadDocumentModule { }